import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Button, Stack, Tooltip, Typography } from "@mui/material";
import { isNil } from "lodash";

interface Props {
  count: number;
  offset: number;
  limit: number;
  nextOffset: number | null;
  previousOffset: number | null;
  onOffsetChange: (offset: number) => void;
  disabled?: boolean;
}

export function CompanySearchPagination(props: Props) {
  const {
    count,
    offset,
    limit,
    nextOffset,
    previousOffset,
    onOffsetChange,
    disabled = false,
  } = props;

  const firstResultOnPage = offset + 1;
  const lastResultOnPage = Math.min(offset + limit, count);

  const isPreviousDisabled = disabled || isNil(previousOffset);
  const isNextDisabled = disabled || isNil(nextOffset);

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      spacing={2}
    >
      {/* Tooltips need an enabled wrapper element to receive hover events. */}
      <Tooltip
        title={
          isPreviousDisabled
            ? "You are on the first page of results"
            : "Show the previous page of companies"
        }
      >
        <span>
          <Button
            size="small"
            startIcon={<ChevronLeftIcon />}
            disabled={isPreviousDisabled}
            onClick={() => onOffsetChange(previousOffset ?? 0)}
          >
            Previous
          </Button>
        </span>
      </Tooltip>
      <Typography variant="body2" color="text.secondary">
        {`Showing ${firstResultOnPage}-${lastResultOnPage} of ${count}`}
      </Typography>
      <Tooltip
        title={
          isNextDisabled
            ? "You are on the last page of results"
            : "Show the next page of companies"
        }
      >
        <span>
          <Button
            size="small"
            endIcon={<ChevronRightIcon />}
            disabled={isNextDisabled}
            onClick={() => onOffsetChange(nextOffset ?? offset)}
          >
            Next
          </Button>
        </span>
      </Tooltip>
    </Stack>
  );
}
